import React from "react";
import { FieldAttributes, useField } from "formik";
import TextField, { TextFieldProps } from "@mui/material/TextField";

const InputField: React.FC<
  FieldAttributes<{}> & { textFieldProps?: TextFieldProps }
> = ({ placeholder, textFieldProps, type, ...inputProps }) => {
  const [field, meta] = useField<{}>(inputProps);
  const errorText = meta.error && meta.touched ? meta.error : "";

  return (
    <TextField
      type={type}
      placeholder={placeholder}
      helperText={errorText}
      error={!!errorText}
      {...field}
      {...(textFieldProps || {})}
    />
  );
};

export default InputField;
